<ng-container *ngIf="collectionSize">
  <span>Items per page</span>
  <select class="page-size-selector"
          [(ngModel)]="pageSize"
          (ngModelChange)="pageSizeChange.emit($event)">
    <option *ngFor="let item of items" [ngValue]="item">{{item}}</option>
  </select>
</ng-container>
